module.exports = __webpack_public_path__ + "static/media/calendar-date.ca6e95b9.svg";